

















import Vue from 'vue';

import Task from '@/models/soukai/Task';

import TasksListItem from './TasksListItem.vue';

export default Vue.extend({
    components: {
        TasksListItem,
    },
    props: {
        tasks: {
            type: Array as () => Task[],
            required: true,
        },
    },
    computed: {
        sortedTasks(): Task[] {
            return this.tasks.slice(0).sort((a: Task, b: Task) => {
                if (a.starred || b.starred)
                    return a.starred ? -1 : 1;

                if (a.dueAt && b.dueAt)
                    return a.dueAt.getTime() - b.dueAt.getTime();

                if (a.dueAt || b.dueAt)
                    return a.dueAt ? -1 : 1;

                return b.createdAt.getTime() - a.createdAt.getTime();
            });
        },
    },
});
